import {Base} from '../../common/model/base.model';
import {Indirizzo} from './indirizzo.model';

export class IndirizzoEntitaLocale extends Base {

  constructor(protected id: number,
                public principale: boolean,
                public indirizzo: Indirizzo
  ) {
    super(id);
  }

  public getLabel() {
    return this.indirizzo.getLabel();
  }

  /**
   * Quando modifico l'entita locale anzichè passare l'id di questo oggetto intermedio passo l'id dell'indirizzo,
   * nell'apposito campo json (indirizzoPrincipale vs altriIndirizzi).
   * @returns {number}
   */
  public referenceValue() {
    return this.indirizzo.getId();
  }
}

